// @ts-nocheck
import { ConfigsRepository } from 'Configs/ConfigsRepository'

export const ColumnVisible = (configsRepository: ConfigsRepository, accessor: string): boolean => {
  const isUniqueIdColumn = accessor === 'uniqueId'
  const showUniqueIdColumn = configsRepository.oauthActive && configsRepository.oauthUniqueId
  return !isUniqueIdColumn || (isUniqueIdColumn && showUniqueIdColumn)
}
